/**
 * @version 0.0.1
 * @description Create and manage the loader inside the document
 * @example
 * import Loader from 'loader.js';
 * Loader.create();
 */
export default class Loader {
    /**
     * @static create
     * @description Create the loader inside the existing loader div
     */
    static create() {
        let loaderHTMLElement = Loader.selectLoaderHTMLElement();

        if (loaderHTMLElement !== null) {
            Loader.tarotLoader(loaderHTMLElement);
        }
    }

    /**
     * @static hide
     * @description hide the loader by setting the display to none
     */
    static hide() {
        const loaderAttrString = '[data-emi-tarot-loader]';

        let loaderHTMLElement = document.querySelector(loaderAttrString);

        if (loaderHTMLElement !== null) {
            loaderHTMLElement.style.display = 'none';
        }
    }

    /**
     * @static selectLoaderHTMLElement
     * @description select the html element identified by the argument data-emi-rune-loader
     * @return {HTMLElement | null}
     */
    static selectLoaderHTMLElement() {
        const loaderAttrString = '[data-emi-tarot-loader]';

        let elt = document.querySelector(loaderAttrString);
        // if a loader element is already in the page use it
        if (elt) {
            let div = document.createElement('div');
            div.classList.add('loader');
            elt.appendChild(div);
            return document.querySelector('[data-emi-tarot-loader] div');
        }
        // else create the element and then do the loader job
        else {
            let loader = document.createElement('div');
            let attr = document.createAttribute('data-emi-tarot-loader');
            attr.value = '';

            loader.setAttributeNode(attr);
            document.body.appendChild(loader);
            let div = document.createElement('div');
            div.classList.add('loader');
            loader.appendChild(div);
            return document.querySelector('[data-emi-tarot-loader] div');
        }
    }

    /**
     * @static
     * @description display the error message for the case where the HTML element for the loader is not found
     */
    static noMaestroError() {
        const msgTitle = 'Woops!!';
        const msgText =
            '<strong>There was a trouble loading your tarot deck!</strong><br/><br/>Please try to reload the page to get a new tarot deck';
        let loader = document.querySelector('[data-emi-tarot-loader]');
        loader.innerHTML = `<div style="position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)"><h1>${msgTitle}</h1><p>${msgText}</p></div>`;
    }

    /**
     * @static tarotLoader
     * @description create and inject inside htmlElement the loader
     * @param {HTMLElement} htmlElement the HTML Element in which to inject the loader
     */
    static tarotLoader(htmlElement) {
        for (let i = 7; i > 0; i--) {
            let elt = document.createElement('div');
            elt.id = 'l0' + i;
            let span = document.createElement('span');
            span.className = 'lds-cd-bd';
            elt.appendChild(span);
            htmlElement.appendChild(elt);
        }
    }
}
